module.exports = __webpack_public_path__ + "static/media/favourite-empty.964f6e07.svg";